import { ReactNgwOl } from './ReactNgwOl';

export default ReactNgwOl;
